// extracted by mini-css-extract-plugin
export default {"container":"TG-z","vocBtn":"UG-z","disabled":"VG-z"};